<template>
  <div data-component-group="filter-forms" data-component="events-promotions">
    <FiltersForm
      v-model="countries"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Dates"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="promotionsStatuses"
        prepend-inner-icon="download_done"
        return-object
        item-title="name"
        label="Status"
      />
    </FiltersForm>
  </div>
</template>

<script>
import FiltersForm from '../FiltersBase';
import { debounce } from '@/utils';
import { v1 as uuidv1 } from 'uuid';
import { mapGetters } from 'vuex';
import filterUrlSync from '@/mixins/filterUrlSync';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

export default {
  mixins: [filterUrlSync],
  components: {
    FiltersForm,
  },
  data() {
    return {
      urlConfig: [
        { field: 'search', urlKey: 'search', type: 'string' },
        { field: 'countries', urlKey: 'countries', type: 'string[]' },
        { field: 'dates', urlKey: 'dates', type: 'string' },
        // The select is return-object, so the URL carries the id and the stub is
        // swapped for the full status once the store listing is in.
        {
          field: 'status', urlKey: 'status', type: 'number', prop: 'id',
          fetchMethod: 'getPromotionsStatuses', itemsField: 'promotionsStatuses',
        },
      ],
      search: null,
      dates: null,
      countries: [],
      dateConfig: {
        mode: 'range',
      },
      status: null,
    };
  },
  computed: {
    ...mapGetters('events', ['promotionsStatuses']),
    hasFilters() {
      const { search, countries, dates, status } = this;
      return search !== null || countries.length > 0 || !!dates || status !== null;
    },
  },
  emits: ['filter', 'clearFilters'],
  methods: {
    onFilter() {
      const { search, countries, dates, status } = this;

      this.syncFiltersToUrl();

      this.$emit('filter', {
        search,
        countries,
        dates: dates || null,
        status: status ? status.id : null,
      });
    },
    onClearFilters() {
      this.search = null;
      this.countries = [];
      this.dates = null;
      this.status = null;

      this.clearFiltersUrl();

      this.$emit('clearFilters');
    },
    onChangeDate(dates) {
      this.dates = dates;
    },
    getPromotionsStatuses() {
      return this.$store.dispatch('events/getPromotionsStatuses');
    },
  },
};
</script>